import React from "react";
import { Flex } from "@chakra-ui/react";
import { useScreenSize } from "hooks/useScreenSize";
import { MobileHeader } from "./MobileHeader";
import { DesktopBanner } from "./DesktopBanner";
import { MobileWeddingBackground } from "./MobileWeddingBackground";
import { VersionHeader } from "./VersionHeader";
import { CenterSection } from "./CenterSection";
import { Reminder } from "./Reminder";
import { Card } from "./Card";

export const WeddingCardSection = React.memo(() => {
  const screenSize = useScreenSize();

  const openURL = React.useCallback(
    () => window.open("https://www.hungfooktong.com/weddingcard/"),
    []
  );

  if (screenSize === "tablet" || screenSize === "desktop") {
    return <DesktopBanner onClick={openURL} />;
  }

  return (
    <Flex
      cursor="pointer"
      width="full"
      flexDirection="column"
      bgColor="brand.500"
      justifyContent="center"
      onClick={openURL}
    >
      <MobileHeader />
      <MobileWeddingBackground />
      <VersionHeader src={require("assets/general-version-header.png")} />
      <CenterSection>
        <Card src={require("assets/general-card.png")} />
      </CenterSection>
      <VersionHeader src={require("assets/personal-version-header.png")} />
      <CenterSection>
        <Card src={require("assets/personal-foreground.png")} />
        <Card src={require("assets/personal-background.png")} />
      </CenterSection>
      <Reminder />
    </Flex>
  );
});
